import i18n from "@/shared/config/i18n";

function getCurrentLocale() {
  try {
    const l = i18n.global.locale;
    return typeof l === "object" && "value" in l ? l.value : l;
  } catch {
    return "ru";
  }
}

export function pickLabel(label, locale) {
  if (!label) return "";
  if (typeof label === "string") return label;
  return (
    label[locale] ||
    label.ru ||
    label.en ||
    label.kz ||
    Object.values(label)[0] ||
    ""
  );
}

export function normalizeStatus(raw, locale = getCurrentLocale()) {
  if (!raw) return { code: "", label: "", labels: {} };
  return {
    code: raw.code,
    label: pickLabel(raw.label, locale),
    labels: typeof raw.label === "object" ? raw.label : { ru: raw.label },
  };
}

export function normalizeStatuses(items, locale) {
  const list = Array.isArray(items)
    ? items
    : Array.isArray(items?.items)
    ? items.items
    : [];

  return list.filter((s) => s && s.code).map((s) => normalizeStatus(s, locale));
}

export function buildRulePayload(rule, formTemplateUuid) {
  return {
    form_template_uuid: formTemplateUuid,
    source_status: rule.source_status,
    target_status: rule.target_status,
    notary_action_codes: rule.notary_action_codes || [],
    allowed_participant_type_codes: rule.allowed_participant_type_codes || [],
    note: rule.note || "",
  };
}

export function buildRuleUpdatePayload(rule) {
  return {
    source_status: rule.source_status,
    target_status: rule.target_status,
    notary_action_codes: rule.notary_action_codes || [],
    allowed_participant_type_codes: rule.allowed_participant_type_codes || [],
    note: rule.note || "",
  };
}
